import Detail from './Detail.container';

export default Detail;
